module.exports = __webpack_public_path__ + "img/counselor_rollet.be846049.png";